import type { Optional } from '@festina-life/core'
import { createContext, useContext } from 'react'

import type { EventSelectionWithApplyDate } from '../components/commitmentEvents/commitmentEventSelectionContext'

type PortfolioSelectionContext = {
  current: Optional<EventSelectionWithApplyDate>
  previous: Optional<EventSelectionWithApplyDate>
  setCurrent: (event: Optional<EventSelectionWithApplyDate>) => void
  setPrevious: (event: Optional<EventSelectionWithApplyDate>) => void
}

const PortfolioSelectionContext =
  createContext<PortfolioSelectionContext | null>(null)

const usePortfolioSelectionContext = () => {
  const context = useContext(PortfolioSelectionContext)

  if (!context) {
    throw new Error(
      'You must wrap your app in a PortfolioProvider to use the PortfolioSelectionContext',
    )
  }

  return context
}

const useOptionalPortfolioSelectionContext =
  (): Partial<PortfolioSelectionContext> => {
    const context = useContext(PortfolioSelectionContext)

    return context ?? {}
  }

const Provider = PortfolioSelectionContext.Provider

export {
  Provider,
  useOptionalPortfolioSelectionContext,
  usePortfolioSelectionContext,
}
